import React, { useEffect, useRef, useState } from 'react';

import TypeaheadSearchResultListItem from './typeaheadSearchResultListItem';

export interface TypeaheadSearchResultProps {
  id: string;
  resultWidth?: number;
  resultList?: TypeaheadSearchResultItem[] | [];
  visible?: boolean;
  multiSelect?: boolean;
  selectedResult?: TypeaheadSearchResultItem | null;
  multiSelectedResult?: TypeaheadSearchResultItem[] | null;
  activeResult?: boolean;
  onItemClick?: Function;
  multiSelectChange?: Function;
}

export interface TypeaheadSearchResultItem {
  id: string;
  value: string;
  label: string;
  link?: string;
}

const TypeaheadSearchResult = ({
  id,
  resultWidth,
  resultList,
  visible,
  multiSelect,
  onItemClick,
  multiSelectChange,
  multiSelectedResult,
}: TypeaheadSearchResultProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [list, setList] = useState<TypeaheadSearchResultItem[]>([]);

  // --------------------------------------------------------------------------------------------------
  //  useEffect - ref.current - sets thwe parent element to position:relative or absolute
  //  -------------------------------------------------------------------------------------------------

  useEffect(() => {
    if (resultList && !list.length) {
      setList(resultList);
    }
  }, [resultList]);

  // --------------------------------------------------------------------------------------------------
  //  useEffect - activeTypeaheadSearch - triggers when the activeTypeaheadSearch context is changed
  //  -------------------------------------------------------------------------------------------------

  useEffect(() => {
    if (resultWidth && ref.current) {
      ref.current.style.width = `${resultWidth}px`;
    }
  }, [resultWidth]);

  const resultItemChange = (item: TypeaheadSearchResultItem, checked: boolean) => {
    if (multiSelectChange) {
      multiSelectChange(item, checked);
    }
  };

  const checkSelected = (item: TypeaheadSearchResultItem) => {
    return multiSelectedResult?.some((selectedItem) => {
      return item.id === selectedItem.id;
    });
  };

  // --------------------------------------------------------------------------------------------------
  // JSX
  // --------------------------------------------------------------------------------------------------

  return (
    <div
      ref={ref}
      id="typeahead-search-result"
      className={`typeahead-search-result ${visible ? 'show' : ''} ${multiSelect ? 'multi-select' : ''}`}
    >
      <ul>
        {resultList?.map((item: TypeaheadSearchResultItem, index) => (
          <li key={item.id}>
            <TypeaheadSearchResultListItem
              id={item.id}
              resultItem={item}
              selected={checkSelected(item)}
              multiSelect={multiSelect}
              multiSelectChange={resultItemChange}
              onItemClick={onItemClick}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TypeaheadSearchResult;
